import React, {Component} from 'react';
import './pricing.css'

class Pricing extends Component{
    render(){
        return(
            <div id="pricing">
              <div className="container">
                <h3>Pricing Options</h3>
                <div className="row">
                  <div className="col-md-3">
                    <p>We have a plan just for you.​ </p>
                    <p>Whether you are a startup or a medium sized enterprise, you can now get on to the digital productivity revolution.</p>
                    <p>Start your trial by downloading the app now.</p>
                    <p>
                      Note: Billing is done yearly in advance subject to a minimum of Rs 1,00,000 per month. All prices shown are excluding applicable taxes.<br/><br/>
                      {/* <span>Additional Workflows will be charged at <br/>Rs 1000 per user/month/workflow.</span> */}
                    </p>
                  </div>
                  <div className="col-md-9">
                    <ul className="list-unstyled">
                      <li>
                        <div className="li-div">
                          <p>Basic</p>
                          <p className="price-content">Up to 5 users​<br/>Basic chat​<br/>Standard task​<br/>All standard reports​</p>
                          <button className="btn pricing-li" style={{position:"relative",top:'90px',boxShadow:'0 2px 6px 0 #50E3C2'}}>Free</button>
                        </div>
                      </li>
                      <li>
                        <div className="li-div">
                          <p>Professional</p>
                          <p className="price-content">Up to 1000 users​<br/>All chat functions​<br/>All task actions​​<br/>Configurable reports​<br/>Add knowledge modules​<br/>1 Free Workflow<br/>1 Web Admin​</p>
                          <button className="btn pricing-li" style={{position:"relative",top:'25px',boxShadow:'0 2px 6px 0 #108BF0'}}>₹ 750*​</button>
                          <p className="pricing-conditions" style={{position:"relative",top:'24px',marginBottom:'0'}}>* per user/month​</p>
                        </div>
                      </li>
                      <li>
                        <div className="li-div">
                          <p>Enterprise</p>
                          <p className="price-content">500-2,000 users​​<br/>All Professional features<br/>5 Web Admins​<br/>Web hooks<br/>BI & Data Visualization**</p>
                          <button className="btn pricing-li" style={{position:"relative",top:'68px',boxShadow:'0 2px 6px 0 #5353C4'}}>₹ 1200*</button>
                          <p className="pricing-conditions" style={{position:"relative",top:'68px',marginBottom:'0'}}>* per user/month<span>** Additional Rs 1000​</span></p>
                        </div>
                      </li>
                    </ul>
                  </div> 
                </div>
              </div>
            </div>
        )
    }
}
export default Pricing;


// WEBPACK FOOTER //
// ./src/components/Pricing/Pricing.js